import { useState } from 'react';
import { Button, Input, Pill } from '@orion/ui';
import { PageHeader } from '../../../app/shell.js';
import { useCreateTag, useDeleteTag, useTagsQuery } from './api.js';

export function TagsAdminPage() {
  const { data: tags, isLoading } = useTagsQuery();
  const createTag = useCreateTag();
  const deleteTag = useDeleteTag();
  const [name, setName] = useState('');

  return (
    <>
      <PageHeader title="Tags" />
      <main className="flex flex-1 flex-col gap-4 p-7">
        <div className="flex gap-2">
          <Input label="New tag" hideLabel value={name} onChange={(e) => setName(e.target.value)} placeholder="Tag name" />
          <Button
            size="sm"
            onClick={async () => {
              if (!name.trim()) return;
              await createTag.mutateAsync({ name, color: '#454A54', entityTypes: ['lead', 'contact', 'company'] });
              setName('');
            }}
            loading={createTag.isPending}
          >
            Add
          </Button>
        </div>

        {!isLoading && (
          <div className="flex flex-wrap gap-2">
            {(tags ?? []).map((t) => (
              <span key={t.id} className="flex items-center gap-2 rounded-full border border-border bg-surface py-1 pl-3 pr-1">
                <Pill label={t.name} color={t.color} />
                <button
                  type="button"
                  aria-label={`Delete tag ${t.name}`}
                  onClick={() => deleteTag.mutate(t.id)}
                  className="flex size-5 items-center justify-center rounded-full text-text-muted hover:bg-surface-subtle"
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        )}
      </main>
    </>
  );
}
